import { supabase } from '../../lib/supabase';
import type { HealthFactor, HealthState } from './towerMetrics';

export type TowerBusiness = {
  id: string; name: string; email: string | null; plan: string; subscriptionStatus: string | null;
  signupDate: string; acquisitionSource: string | null; lastActive: string | null;
  jobs: number; quotes: number; invoices: number; expenses: number; healthScore: number;
  healthState: HealthState; healthFactors: HealthFactor[]; primarySignal: string;
};

export type TowerSnapshot = {
  period: { from: string; to: string };
  metrics: Record<string, number | null>;
  previous: Record<string, number | null>;
  funnel: Record<string, number | null>;
  businesses: TowerBusiness[];
  featureUsage: Array<{ name: string; businesses: number; percent: number | null }>;
  channels: Array<{ name: string; signups: number; activated: number; paid: number; mrr: number | null }>;
  retention: Array<{ cohort: string; size: number; w1: number | null; w4: number | null; w8: number | null; w12: number | null }>;
};

export async function fetchTowerSnapshot(from: string, to: string): Promise<TowerSnapshot> {
  const { data, error } = await supabase.rpc('tower_get_snapshot', { p_from: from, p_to: to });
  if (error) throw error;
  return data as TowerSnapshot;
}
